import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import PopupNotification from '@/modules/Notifications/components/PopupNotification.vue';
import { PopupNotificationOptions } from '@/modules/Notifications/interfaces/PopupNotificationOptions';
import { RouteNames } from '@/enums/routes/RouteNames';
import router from '@/router';

interface Props {
    notifications: PopupNotificationOptions[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupNotifications',
  props: {
    notifications: null
  },
  setup(__props: any) {

const props = __props as {
    notifications: PopupNotificationOptions[];
};



const rightMargin = ref(40);
const topMargin = ref(40);
const position = ref('fixed');
const notificationsAreVisible = ref(true);

if (router.currentRoute.name === RouteNames.calculatorProduct) {
    rightMargin.value = -50;
    topMargin.value = 60;
    position.value = 'absolute';
}

const notificationIconInfo = computed(() => {
    const obj = {
        icon: '',
        color: '',
    };

    if (props.notifications.length) {
        obj.icon =
            props.notifications[0].icon ||
            (props.notifications[0].errorType === 'error' ? 'close-circle' : 'exclamation-circle');
        obj.color = 'color:' + (props.notifications[0].errorType === 'error' ? '#f5222d' : '#ffbf00');
    } else {
        obj.icon = 'check-circle';
        obj.color = 'color: #52c41a';
    }

    return obj;
});

return { __sfc: true,props, rightMargin, topMargin, position, notificationsAreVisible, notificationIconInfo, PopupNotification }
}

})